// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx","774":"framework"}[chunkId] + "-" + {"218":"475156c675ca6cb03bd9","691":"a8c29e1388bdfd2ce480","774":"62eb5ed98b92d37ba1c3"}[chunkId] + ".js";
};